var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _vm.form.parentCode
        ? _c(
            "el-col",
            { attrs: { span: 22 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "SettingBaseDataRegion.addAndEdit.superiorArea"
                    ),
                    prop: "parentName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      disabled: "",
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.parentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "parentName", $$v)
                      },
                      expression: "form.parentName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataRegion.addAndEdit.code"),
                prop: "areaCode",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  disabled: _vm.isEdit,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.areaCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "areaCode", $$v)
                  },
                  expression: "form.areaCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataRegion.addAndEdit.name"),
                prop: "name",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataRegion.addAndEdit.abbreviation"),
                prop: "shortName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.shortName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "shortName", $$v)
                  },
                  expression: "form.shortName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }